// removed by extract-text-webpack-plugin
module.exports = {"bofa":"Bank__bofa___3Clps","name":"Bank__name___1HVVr","error":"Bank__error___30vcc","disclosure":"Bank__disclosure___1cIuJ","reminder":"Bank__reminder___2RgvQ"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/types/bank/Bank.less
 ** module id = 773
 ** module chunks = 0
 **/